import { makeStyles, tokens } from "@fluentui/react-components";
import { flexParent } from "../utilities/Mixin.styles";
/**
 * Styles for the LinkDetailsEditorDialog component
 */ export const useLinkDetailsEditorDialogStyles = makeStyles({
    dialogSurface: {
        minHeight: "auto",
        borderRadius: tokens.borderRadiusLarge,
        maxWidth: "600px",
        backgroundColor: tokens.colorNeutralBackground1,
        padding: 0
    },
    form: {
        ...flexParent("column"),
        height: "100%",
        width: "100%",
        margin: tokens.spacingVerticalNone,
        padding: tokens.spacingVerticalNone
    },
    dialogBody: {
        backgroundColor: tokens.colorNeutralBackground1,
        padding: tokens.spacingHorizontalXXL,
        borderRadius: tokens.borderRadiusLarge
    },
    content: {
        ...flexParent("column"),
        gap: tokens.spacingVerticalM,
        fontSize: tokens.fontSizeBase200
    },
    customLabel: {
        color: tokens.colorNeutralForeground2,
        fontSize: tokens.fontSizeBase200,
        paddingBottom: tokens.spacingVerticalXXS,
        fontWeight: tokens.fontWeightRegular,
        display: "block"
    },
    errorMessage: {
        color: tokens.colorPaletteRedForeground1,
        fontSize: tokens.fontSizeBase200,
        paddingTop: tokens.spacingVerticalXXS,
        display: "block"
    },
    addressContainer: {
        ...flexParent("column"),
        paddingBottom: tokens.spacingVerticalM
    },
    displayTextContainer: {
        ...flexParent("column"),
        paddingBottom: tokens.spacingVerticalM
    },
    input: {
        width: "100%",
        fontSize: tokens.fontSizeBase200
    },
    prefix: {
        color: tokens.colorNeutralForeground2,
        fontSize: tokens.fontSizeBase200,
        whiteSpace: "nowrap"
    },
    dialogActions: {
        gap: tokens.spacingHorizontalM,
        justifyContent: "flex-end",
        paddingTop: tokens.spacingVerticalXXS
    },
    button: {
        borderRadius: tokens.borderRadiusXLarge
    }
});
